import styled from 'particles/themes/styled'

interface RangeInputContainerProps {
    isVertical: boolean
    isCard?: boolean
    width?: string
}

export const RangeInputContainer = styled.div<RangeInputContainerProps>`
    width: ${({ width }) => (width ? width : 'fit-content')};
    box-sizing: border-box;
    gap: ${({ theme }) => theme.spacing[200]};
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 768px) {
        max-width: 100%;
        width: 100%;
    }
    .range-input {
        width: 100%;
        display: flex;
        flex-direction: ${({ isVertical }) => (isVertical ? 'column' : 'row')};
        justify-content: flex-start;
        align-items: ${({ isVertical }) => (isVertical ? 'flex-start' : 'center')};
        gap: ${({ theme, isVertical }) => theme.spacing[isVertical ? 300 : 200]};

        .to-block {
            padding: 0px 8px;
        }
    }
`
